import React from 'react';
import './App.css';
import profile from "./images/profile.jpg";

const SocialIcon = ({ href, icon, label }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" title={label} className="social-icon">
    <svg viewBox="0 0 24 24" fill="currentColor">
      {icon}
    </svg>
    <span className="sr-only">{label}</span>
  </a>
);

export default function App() {
  return (
    <div id="wrapper">
      <section id="main">
        <header>
          <div className="avatar">
            <img src={profile} alt="Dr. Juan Miguel Cejuela" />
          </div>
          <h1 className="name">Dr. Juan Miguel Cejuela</h1>
          <div className="tagline">
            <span className="role">AI Engineer & Data Scientist</span>
            <span className="separator">•</span>
            <span className="role">Security Architect</span>
          </div>

          <div className="bio">
            <p>Builder of secure, intelligent systems that just work.</p>
            <p>Available for <a href="mailto:preload-dry-0w+juanmirocks@icloud.com">consulting projects</a>.</p>
          </div>

          <div className="cta">
            <p>Let’s connect and deliver <strong>solutions</strong> together</p>
          </div>

          <div className="social-links">
            <SocialIcon
              href="mailto:preload-dry-0w+juanmirocks@icloud.com"
              label="Email"
              icon={<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>}
            />
            <SocialIcon
              href="https://www.linkedin.com/in/juanmirocks"
              label="LinkedIn"
              icon={<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>}
            />
            <SocialIcon
              href="https://stackoverflow.com/users/341320/juanmirocks"
              label="StackOverflow"
              icon={<path d="M18.986 21.865v-6.404h2.134V24H1.844v-8.539h2.13v6.404h15.012zM6.111 19.731H16.85v-2.137H6.111v2.137zm.259-4.852l10.48 2.189.451-2.07-10.478-2.187-.453 2.068zm1.359-5.056l9.705 4.53.903-1.95-9.706-4.53-.902 1.95zm2.715-4.785l8.217 6.855 1.359-1.62-8.216-6.853-1.36 1.618zM15.539 0l-1.7 1.265 6.405 8.603 1.7-1.265L15.539 0z"/>}
            />
            <SocialIcon
              href="https://github.com/juanmirocks"
              label="GitHub"
              icon={<path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>}
            />
          </div>
        </header>
      </section>

      <footer id="footer">
        <ul className="copyright">
          <li>© Dr. Juan Miguel Cejuela</li>
        </ul>
      </footer>
    </div>
  );
}

if (typeof window !== 'undefined' && 'addEventListener' in window) {
  window.addEventListener('load', () => {
    document.body.className = document.body.className.replace(/\bis-loading\b/, '');
  });
}
